<template>
  <div :ref="chartRefId" :style="{ width: '100%', height: '400px' }"></div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  name: 'GenericScatterChart',

  props: {
    config: {
      type: Object,
      required: true
    },

    data: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      chartRefId: `scatter-chart-${this._uid}`,
      chartInstance: null
    };
  },

  mounted() {
    this.initChart();
    window.addEventListener('resize', this.resizeChart);
  },

  watch: {
    config: {
      deep: true,
      handler() {
        this.updateChart();
      }
    },

    data: {
      deep: true,
      handler() {
        this.updateChart();
      }
    }
  },

  methods: {
    initChart() {
      const chartEl = this.$refs[this.chartRefId];
      if (!chartEl) return;

      this.chartInstance = echarts.init(chartEl);
      this.updateChart();
    },

    buildOption() {
      const xField = this.config.xAxis.field;
      const yField = this.config.yAxis.field;

      const xType = this.config.xAxis.type;
      const yType = this.config.yAxis.type;

      const data = this.data || [];

      let seriesData = [];
      let xCategories = [];

      for (let i = 0; i < data.length; i++) {
        const row = data[i];

        const xVal = row[xField];
        const yVal = Number(row[yField]);

        if (xType === 'category') {
          // store categories for axis
          xCategories.push(xVal);

          // IMPORTANT: scatter still uses numeric pair positionally
          seriesData.push([xVal, yVal]);
        } else {
          seriesData.push([
            Number(xVal),
            yVal
          ]);
        }
      }

      return {
        title: {
          text: this.config.title || '',
          left: 'center'
        },

        tooltip: {
          trigger: 'item',
          formatter: function (params) {
            return params.value[0] + ': ' + params.value[1];
          }
        },

        xAxis: {
          type: xType,
          data: xType === 'category' ? xCategories : undefined
        },

        yAxis: {
          type: yType
        },

        series: [
          {
            type: 'scatter',
            symbolSize: this.config.symbolSize || 10,
            data: seriesData,
            itemStyle: {
              color: "#FFD38A"
            }
          }
        ]
      };
    },

    updateChart() {
      if (!this.chartInstance) return;

      this.chartInstance.setOption(
        this.buildOption(),
        true
      );
    },

    resizeChart() {
      if (this.chartInstance) {
        this.chartInstance.resize();
      }
    },

    getChartInstance() {
      return this.chartInstance;
    }
  },

  beforeUnmount() {
    window.removeEventListener('resize', this.resizeChart);

    if (this.chartInstance) {
      this.chartInstance.dispose();
    }
  }
};
</script>